import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import * as moment from "moment";
import { GlobalsService } from './globals';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    token: string;
    etiquetas: any;

    constructor(
        private globals: GlobalsService,
        private toastrService: ToastrService) {
        this.globals.getTranslate('globals').subscribe((resp: any) => {
            this.etiquetas = resp;
        });
        this.globals.dataFirstSub.subscribe((resp: any) => {
            this.token = resp.user.token;
        });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = (this.globals.user) ? this.globals.user.token : this.token;
        if (token !== undefined && token !== null && token !== '') {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Timezone':  moment().zone().toString()
                },
            });
            // return next.handle(request);
            return next.handle(request).pipe(
                map((event: HttpEvent<any>) => {
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this.toastrService.error(this.etiquetas.message.credenciales, this.etiquetas.message.error, {
                            timeOut: 0
                        });
                    }
                    return throwError(error);
                })
            );
        } else {
            return next.handle(request).pipe(
                map((event: HttpEvent<any>) => {
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 401) {
                        this.toastrService.error(this.etiquetas.message.credentials, this.etiquetas.message.error, {
                            timeOut: 0
                        });
                    }
                    return throwError(error);
                })
            );
        }
    }

    getTranslate() {
        this.globals.getTranslate('globals').subscribe((resp: any) => {
            // console.log(resp);
            this.etiquetas = resp;
        });
    }
}
